import React, { useState } from "react";

export default function GradeLevelsTable() {
  // Initial mock data for grade levels
  const [gradeLevels, setGradeLevels] = useState([
    { id: 1, name: "Nursery", description: "Early Childhood Education" },
    { id: 2, name: "Kinder", description: "Kindergarten" },
    { id: 3, name: "Grade 1", description: "Primary Education" },
    { id: 4, name: "Grade 2", description: "Primary Education" },
    { id: 5, name: "Grade 3", description: "Primary Education" },
    { id: 6, name: "Grade 4", description: "Primary Education" },
    { id: 7, name: "Grade 5", description: "Primary Education" },
    { id: 8, name: "Grade 6", description: "Primary Education" },
    { id: 9, name: "Grade 7", description: "Junior High School" },
    { id: 10, name: "Grade 8", description: "Junior High School" },
    { id: 11, name: "Grade 9", description: "Junior High School" },
    { id: 12, name: "Grade 10", description: "Junior High School" },
    { id: 13, name: "Grade 11", description: "Senior High School" },
    { id: 14, name: "Grade 12", description: "Senior High School" },
  ]);

  // State for new grade level form
  const [newGradeLevel, setNewGradeLevel] = useState({ name: "", description: "" });

  // Add new grade level
  const handleAddGradeLevel = (e) => {
    e.preventDefault();
    if (!newGradeLevel.name.trim()) return;
    setGradeLevels([
      ...gradeLevels,
      { id: Date.now(), name: newGradeLevel.name, description: newGradeLevel.description },
    ]);
    setNewGradeLevel({ name: "", description: "" });
  };

  // Edit grade level
  const handleEditGradeLevel = (id, updatedGradeLevel) => {
    setGradeLevels(gradeLevels.map(g => (g.id === id ? { ...g, ...updatedGradeLevel } : g)));
  };

  // Delete grade level
  const handleDeleteGradeLevel = (id) => {
    setGradeLevels(gradeLevels.filter(g => g.id !== id));
  };

  // Inline edit state
  const [editId, setEditId] = useState(null);
  const [editGradeLevel, setEditGradeLevel] = useState({ name: "", description: "" });

  return (
    <div>
      <form className="mb-4" onSubmit={handleAddGradeLevel} style={{ display: "flex", gap: 8 }}>
        <input
          className="form-control"
          style={{ maxWidth: 180 }}
          type="text"
          placeholder="Grade Level Name"
          value={newGradeLevel.name}
          onChange={e => setNewGradeLevel({ ...newGradeLevel, name: e.target.value })}
          required
        />
        <input
          className="form-control"
          style={{ maxWidth: 320 }}
          type="text"
          placeholder="Description"
          value={newGradeLevel.description}
          onChange={e => setNewGradeLevel({ ...newGradeLevel, description: e.target.value })}
        />
        <button className="btn btn-success" type="submit">Add Grade Level</button>
      </form>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th style={{ width: 120 }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {gradeLevels.map(gradeLevel => (
            <tr key={gradeLevel.id}>
              <td>
                {editId === gradeLevel.id ? (
                  <input
                    className="form-control"
                    value={editGradeLevel.name}
                    onChange={e => setEditGradeLevel({ ...editGradeLevel, name: e.target.value })}
                  />
                ) : (
                  gradeLevel.name
                )}
              </td>
              <td>
                {editId === gradeLevel.id ? (
                  <input
                    className="form-control"
                    value={editGradeLevel.description}
                    onChange={e => setEditGradeLevel({ ...editGradeLevel, description: e.target.value })}
                  />
                ) : (
                  gradeLevel.description
                )}
              </td>
              <td>
                {editId === gradeLevel.id ? (
                  <>
                    <button
                      className="btn btn-primary btn-sm me-2"
                      onClick={() => {
                        handleEditGradeLevel(gradeLevel.id, editGradeLevel);
                        setEditId(null);
                      }}
                    >Save</button>
                    <button
                      className="btn btn-secondary btn-sm"
                      onClick={() => setEditId(null)}
                    >Cancel</button>
                  </>
                ) : (
                  <>
                    <button
                      className="btn btn-warning btn-sm me-2"
                      onClick={() => {
                        setEditId(gradeLevel.id);
                        setEditGradeLevel({ name: gradeLevel.name, description: gradeLevel.description });
                      }}
                    >Edit</button>
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDeleteGradeLevel(gradeLevel.id)}
                    >Delete</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}